import React from 'react';
import { Avatar, Chip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import router from 'next/router';
import clsx from 'clsx';

import LocationIcon from 'public/icons/profile/location.svg';
import NoAvatarImage from 'public/images/no-avatar.svg';
import useIsBuyer from 'hooks/useIsBuyer';
import useCurrentProfile from 'hooks/useCurrentProfile';
import useIsAdvertiser from 'hooks/useIsAdvertiser';
import useOnlyFansConnections from 'hooks/useOnlyFansConnections';
import TeamIcon from 'public/icons/profile/team.svg';
import GraduationHatIcon from 'public/icons/profile/graduation-hat.svg';
import ProfileRatingStar from 'components/advertiserProfile/ProfileRatingStar';
import styles from 'styles/components/profile/Card.module.scss';

const avatarSize = { width: 70, height: 70 };
const avatarFullSize = { width: '100%', height: '100%' };

const ProfileCard = () => {
  const currentUser = useSelector(state => state.auth.currentUser);
  const isAdvertiser = useIsAdvertiser();
  const profile = useCurrentProfile();
  const isBuyer = useIsBuyer();
  const displayName = isAdvertiser
    ? currentUser.display_name
    : profile?.display_name || currentUser.display_name;

  const { onlyFansConnected } = useOnlyFansConnections();

  return (
    <div
      className={clsx(styles.profileCard, {
        [styles.onlyFansConnected]: onlyFansConnected,
      })}
      onClick={() =>
        router.push(isAdvertiser ? `c/${currentUser.username}` : `u/${profile.username}`)
      }
    >
      {onlyFansConnected && (
        <div style={{ position: 'absolute', top: '-12px', right: 5 }}>
          <Chip
            label={`${isBuyer ? 'Buyer' : 'Seller'} OnlyFans Connected`}
            className="blue-chip"
          />
        </div>
      )}

      <Avatar src={currentUser.avatar_url || profile?.avatar_url} style={avatarSize} alt="Cover">
        <NoAvatarImage style={avatarFullSize} />
      </Avatar>

      <div style={{ marginLeft: 10 }}>
        <h3 className={styles.name}>{displayName}</h3>

        {!profile?.athlete && (
          <div className={styles.location}>
            {currentUser.location && <LocationIcon width={12} height={12} />}

            <h5>
              {currentUser.location || profile?.location
                ? currentUser.location || profile?.location
                : currentUser.location || profile?.location}
            </h5>
          </div>
        )}

        {profile?.athlete && (
          <div className={styles.location}>
            {profile.athlete_level === 'professional_athlete' ? (
              <TeamIcon width={12} height={12} style={{ fill: '#323643', opacity: 0.5 }} />
            ) : (
              <GraduationHatIcon width={12} height={12} style={{ fill: '#323643', opacity: 0.5 }} />
            )}

            <h5>
              {profile.athlete_level === 'professional_athlete'
                ? profile.team_name
                : profile.school_name || profile.school.name}
            </h5>
          </div>
        )}

        <ProfileRatingStar
          rating={profile?.average_rating || currentUser.average_rating}
          gigsCount={profile?.working_stats?.gigs_count}
        />
      </div>

      <small
        style={{ position: 'absolute', right: 15, bottom: 11, fontSize: 12 }}
        className="color-main"
      >
        View My Profile
      </small>
    </div>
  );
};

export default ProfileCard;
